<template>
  <div class="header-row">
    <div class="left-menu">
      <span class="text">Дата:</span>
      <div class="period">
        <div class="right-inner-addon">
          <date-picker  v-bind:value="value" v-on:input="$emit('input', $event)" format="DD.MM.YYYY" :lang="lang" :disabled-date="disabledAfterToday"></date-picker>
        </div>
      </div>
    </div>
    <div class="block">
      <div v-tooltip.top-center="" class="cart">
        <span>Вільний залишок для розподілу: &nbsp;</span><b>{{data.balance | toCurrency}}</b>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
import  moment from "moment";
moment.defineLocale('uk', null)
export default {
  name: 'WalletHeader',
  props: ["value"],
  components: {
    DatePicker
  },
  created() {
    this.getData()
  },
  methods: {
    disabledAfterToday(date){
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    getData(){
      this.axios.get('/userservice/v1/User/balance-for-distribution', {params: {onDate: moment(this.value).format('YYYY-MM-DD') + ' 00:00:00'}})
          .then(
              (distribution) => {
                this.data = distribution.data
              })
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
    }
    //
  },
  data() {
    return {
      data: {},
      lang: {
        monthFormat: 'MMMM',

        // formatLocale: {
        //   firstDayOfWeek: 1,
        // },
        // monthBeforeYear: false,
      },
    }
  }
}
</script>
<style>
.header-row {
  display: flex;

}
.col-wallets .cart {
  width: 100%;
  margin-left: 40px;
}

</style>